import { LookupValues } from 'src/utils/types';
import { ClickstreamEnvelope } from '../types';

export const CALLBACK_SCHEDULER_INTERACTION_EVENTS = {
    CALLBACK_SCHEDULER_BOOK_APPOINTMENT_CLICK: 'CALLBACK_SCHEDULER_BOOK_APPOINTMENT_CLICK',
    CALLBACK_SCHEDULER_EXIT_CLICK: 'CALLBACK_SCHEDULER_EXIT_CLICK',
    CALLBACK_SCHEDULER_SUCCESS_DASHBOARD_BUTTON_CLICK: 'CALLBACK_SCHEDULER_SUCCESS_DASHBOARD_BUTTON_CLICK',
    CALLBACK_SCHEDULER_FAILURE_DASHBOARD_BUTTON_CLICK: 'CALLBACK_SCHEDULER_FAILURE_DASHBOARD_BUTTON_CLICK',
} as const;

export type CallbackSchedulerInteractionEvent = LookupValues<typeof CALLBACK_SCHEDULER_INTERACTION_EVENTS>;

export const CALLBACK_SCHEDULER_IMPRESSION_EVENTS = {
    CALLBACK_SCHEDULER_APPOINTMENT_BOOKER_LOADED: 'CALLBACK_SCHEDULER_APPOINTMENT_BOOKER_LOADED',
    CALLBACK_SCHEDULER_APPOINTMENT_CONFIRMED: 'CALLBACK_SCHEDULER_APPOINTMENT_CONFIRMED',
    CALLBACK_SCHEDULER_APPOINTMENT_FAILED: 'CALLBACK_SCHEDULER_APPOINTMENT_FAILED',
} as const;

export type CallbackSchedulerImpressionEvent = LookupValues<typeof CALLBACK_SCHEDULER_IMPRESSION_EVENTS>;

export const HOME_LOANS_DASHBOARD_INTERACTION_EVENTS = {
    PRIMARY_CTA_CLICK: 'HOME_LOANS_DASHBOARD_PRIMARY_CTA_CLICK',
    SECONDARY_CTA_CLICK: 'HOME_LOANS_DASHBOARD_SECONDARY_CTA_CLICK',
    RESOURCE_CARD_PRIMARY_CTA_CLICK: 'HOME_LOANS_DASHBOARD_RESOURCE_CARD_PRIMARY_CTA_CLICK',
    RESOURCE_CARD_MODAL_BACKDROP_CLICK: 'HOME_LOANS_DASHBOARD_RESOURCE_CARD_MODAL_BACKDROP_CLICK',
    RESOURCE_CARD_MODAL_CLOSE_CLICK: 'HOME_LOANS_DASHBOARD_RESOURCE_CARD_MODAL_CLOSE_CLICK',
    RESOURCE_CARD_MODAL_PRIMARY_CTA_CLICK: 'HOME_LOANS_DASHBOARD_RESOURCE_CARD_MODAL_PRIMARY_CTA_CLICK',
    TEAM_INFORMATION_CARD_CALL_CTA_CLICK: 'HOME_LOANS_DASHBOARD_TEAM_INFORMATION_CARD_CALL_CTA_CLICK',
    TEAM_INFORMATION_CARD_CALL_OR_TEXT_CTA_CLICK: 'HOME_LOANS_DASHBOARD_TEAM_INFORMATION_CARD_CALL_OR_TEXT_CTA_CLICK',
    TEAM_INFORMATION_CARD_EMAIL_CTA_CLICK: 'HOME_LOANS_DASHBOARD_TEAM_INFORMATION_CARD_EMAIL_CTA_CLICK',
    SAVED_INFORMATION_PRIMARY_CTA_CLICK: 'HOME_LOANS_DASHBOARD_SAVED_INFORMATION_PRIMARY_CTA_CLICK',
} as const;

export type HomeLoansDashboardInteractionEvent = LookupValues<typeof HOME_LOANS_DASHBOARD_INTERACTION_EVENTS>;

export const HOME_LOANS_DASHBOARD_IMPRESSION_EVENTS = {
    UPSELL_MODULE_LOADED: 'HOME_LOANS_DASHBOARD_UPSELL_MODULE_LOADED',
    RESOURCE_CARD_MODULE_LOADED: 'HOME_LOANS_DASHBOARD_RESOURCE_CARD_MODULE_LOADED',
    TEAM_INFORMATION_CARD_MODULE_LOADED: 'HOME_LOANS_DASHBOARD_TEAM_INFORMATION_CARD_MODULE_LOADED',
    VIEW_SAVED_INFORMATION_CARD_MODULE_LOADED: 'HOME_LOANS_DASHBOARD_VIEW_SAVED_INFORMATION_CARD_MODULE_LOADED',
    REDIRECT_TO_GOLDENEYE: 'HOME_LOANS_DASHBOARD_BOUNCE_REDIRECT_TO_GOLDENEYE',
    REDIRECT_TO_DASHBOARD: 'HOME_LOANS_DASHBOARD_BOUNCE_REDIRECT_TO_DASHBOARD',
} as const;
export type HomeLoansDashboardImpressionEvent = LookupValues<typeof HOME_LOANS_DASHBOARD_IMPRESSION_EVENTS>;

export const HOME_LOANS_DASHBOARD_VIEW_EVENTS = {
    DASHBOARD_LOADED: 'HOME_LOANS_DASHBOARD_LOADED',
    DASHBOARD_BOUNCE_LOADED: 'HOME_LOANS_DASHBOARD_BOUNCE_LOADED',
} as const;

export type HomeLoansDashboardViewEvent = LookupValues<typeof HOME_LOANS_DASHBOARD_VIEW_EVENTS>;

export const REGISTERED_CLICKSTREAM_EVENTS = {
    UNIVERSAL_CALL_ZHL: 'CALL_ZHL',
    UNIVERSAL_CLOSE_ABAD_ON_ZHL: 'CLOSE_ABAD_ON_ZHL',
    UNIVERSAL_VIEW_ABAD_ON_ZHL: 'VIEW_ABAD_ON_ZHL',
    UNIVERSAL_START_ZHL_FUNNEL: 'START_ZHL_FUNNEL',
    UNIVERSAL_START_ZHL_PURCHASE_FUNNEL: 'START_ZHL_PUCHASE_PREQUAL_FUNNEL',
    UNIVERSAL_START_ZHL_REFINANCE_FUNNEL: 'START_ZHL_REFINANCE_FUNNEL',
    UNIVERSAL_START_PREQUAL_BUTTON_CLICK: 'START_PREQUAL_BUTTON_CLICK',
    ...HOME_LOANS_DASHBOARD_INTERACTION_EVENTS,
    ...HOME_LOANS_DASHBOARD_IMPRESSION_EVENTS,
    ...HOME_LOANS_DASHBOARD_VIEW_EVENTS,
    ...CALLBACK_SCHEDULER_INTERACTION_EVENTS,
    ...CALLBACK_SCHEDULER_IMPRESSION_EVENTS,
} as const;
export type RegisteredClickstreamEvents = LookupValues<typeof REGISTERED_CLICKSTREAM_EVENTS>;

/**
 * Events details can be found at https://dataportal.zillowgroup.net/event-registry/${eventTypeID}
 */
export const CLICKSTREAM_EVENT_ENVELOPES: Record<RegisteredClickstreamEvents, ClickstreamEnvelope> = {
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_CALL_ZHL]: {
        event_type_id: '2098',
        event_template_id: '127',
        event_template_version_id: '1',
        event_type_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_CLOSE_ABAD_ON_ZHL]: {
        event_template_id: '131',
        event_template_version_id: '1',
        event_type_id: '2086',
        event_type_version_id: '2',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_FUNNEL]: {
        event_template_id: '37',
        event_template_version_id: '1',
        event_type_id: '2103',
        event_type_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_PURCHASE_FUNNEL]: {
        event_type_id: '2093',
        event_type_version_id: '2',
        event_template_id: '194',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_REFINANCE_FUNNEL]: {
        event_type_id: '2080',
        event_type_version_id: '2',
        event_template_id: '194',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_VIEW_ABAD_ON_ZHL]: {
        event_template_id: '131',
        event_template_version_id: '1',
        event_type_id: '2083',
        event_type_version_id: '2',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_PREQUAL_BUTTON_CLICK]: {
        event_type_id: '647',
        event_type_version_id: '1',
        event_template_id: '116',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.PRIMARY_CTA_CLICK]: {
        event_type_id: '4347',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.SECONDARY_CTA_CLICK]: {
        event_type_id: '4348',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_PRIMARY_CTA_CLICK]: {
        event_type_id: '4318',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_BACKDROP_CLICK]: {
        event_type_id: '4331',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_CLOSE_CLICK]: {
        event_type_id: '4332',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_PRIMARY_CTA_CLICK]: {
        event_type_id: '4349',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_CALL_CTA_CLICK]: {
        event_type_id: '4350',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_CALL_OR_TEXT_CTA_CLICK]: {
        event_type_id: '4335',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_EMAIL_CTA_CLICK]: {
        event_type_id: '4336',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.SAVED_INFORMATION_PRIMARY_CTA_CLICK]: {
        event_type_id: '4337',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.DASHBOARD_LOADED]: {
        event_type_id: '4345',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.DASHBOARD_BOUNCE_LOADED]: {
        event_type_id: '4346',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.UPSELL_MODULE_LOADED]: {
        event_type_id: '4338',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODULE_LOADED]: {
        event_type_id: '4340',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_MODULE_LOADED]: {
        event_type_id: '4341',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.VIEW_SAVED_INFORMATION_CARD_MODULE_LOADED]: {
        event_type_id: '4342',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.REDIRECT_TO_GOLDENEYE]: {
        event_type_id: '4343',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.REDIRECT_TO_DASHBOARD]: {
        event_type_id: '4344',
        event_type_version_id: '1',
        event_template_id: '266',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_BOOKER_LOADED]: {
        event_type_id: '6602',
        event_type_version_id: '2',
        event_template_id: '127',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_BOOK_APPOINTMENT_CLICK]: {
        event_type_id: '6603',
        event_type_version_id: '3',
        event_template_id: '127',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_EXIT_CLICK]: {
        event_type_id: '6604',
        event_type_version_id: '4',
        event_template_id: '127',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_CONFIRMED]: {
        event_type_id: '6605',
        event_type_version_id: '3',
        event_template_id: '127',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_SUCCESS_DASHBOARD_BUTTON_CLICK]: {
        event_type_id: '6606',
        event_type_version_id: '5',
        event_template_id: '127',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_FAILURE_DASHBOARD_BUTTON_CLICK]: {
        event_type_id: '6606',
        event_type_version_id: '5',
        event_template_id: '127',
        event_template_version_id: '1',
    },
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_FAILED]: {
        event_type_id: '6605',
        event_type_version_id: '3',
        event_template_id: '127',
        event_template_version_id: '1',
    },
};
export const ZEP_EVENTS = {
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_CALL_ZHL]: 'mortgage.homeloans-dashboard-product.call-initiated',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_CLOSE_ABAD_ON_ZHL]:
        'mortgage.homeloans-dashboard-product.universal-flow-abad-closed',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_VIEW_ABAD_ON_ZHL]:
        'mortgage.homeloans-dashboard-product.universal-flow-abad-viewed',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_FUNNEL]:
        'mortgage.homeloans-dashboard-product.universal-flow-start-zhl-funnel-viewed',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_PURCHASE_FUNNEL]:
        'mortgage.homeloans-dashboard-product.universal-flow-zhl-purchase-funnel-started',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_REFINANCE_FUNNEL]:
        'mortgage.homeloans-dashboard-product.universal-flow-zhl-refinance-funnel-started',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_PREQUAL_BUTTON_CLICK]:
        'mortgage.homeloans-dashboard-product.universal-flow-start-prequal-button-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.PRIMARY_CTA_CLICK]: 'mortgage.homeloans-dashboard-product.primary-cta-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.SECONDARY_CTA_CLICK]: 'mortgage.homeloans-dashboard-product.secondary-cta-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_PRIMARY_CTA_CLICK]:
        'mortgage.homeloans-dashboard-product.resource-card-primary-cta-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_BACKDROP_CLICK]:
        'mortgage.homeloans-dashboard-product.resource-card-modal-backdrop-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_CLOSE_CLICK]:
        'mortgage.homeloans-dashboard-product.resource-card-modal-close-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_PRIMARY_CTA_CLICK]:
        'mortgage.homeloans-dashboard-product.resource-card-modal-primary-cta-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_CALL_CTA_CLICK]:
        'mortgage.homeloans-dashboard-product.team-information-card-call-cta-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_CALL_OR_TEXT_CTA_CLICK]:
        'mortgage.homeloans-dashboard-product.team-information-card-call-or-text-cta-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_EMAIL_CTA_CLICK]:
        'mortgage.homeloans-dashboard-product.information-card-email-cta-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.SAVED_INFORMATION_PRIMARY_CTA_CLICK]:
        'mortgage.homeloans-dashboard-product.saved-information-primary-cta-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.DASHBOARD_LOADED]: 'mortgage.homeloans-dashboard-product.dashboard-loaded',
    [REGISTERED_CLICKSTREAM_EVENTS.DASHBOARD_BOUNCE_LOADED]:
        'mortgage.homeloans-dashboard-product.dashboard-bounce-loaded',
    [REGISTERED_CLICKSTREAM_EVENTS.UPSELL_MODULE_LOADED]: 'mortgage.homeloans-dashboard-product.upsell-module-loaded',
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODULE_LOADED]:
        'mortgage.homeloans-dashboard-product.resource-card-module-loaded',
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_MODULE_LOADED]:
        'mortgage.homeloans-dashboard-product.team-information-card-module-loaded',
    [REGISTERED_CLICKSTREAM_EVENTS.VIEW_SAVED_INFORMATION_CARD_MODULE_LOADED]:
        'mortgage.homeloans-dashboard-product.view-saved-information-card-module-loaded',
    [REGISTERED_CLICKSTREAM_EVENTS.REDIRECT_TO_GOLDENEYE]: 'mortgage.homeloans-dashboard-product.goldeneye-redirect',
    [REGISTERED_CLICKSTREAM_EVENTS.REDIRECT_TO_DASHBOARD]: 'mortgage.homeloans-dashboard-product.dashboard-redirect',
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_BOOKER_LOADED]:
        'mortgage.homeloans-dashboard-product.call-scheduler-appointment-booker-loaded',
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_BOOK_APPOINTMENT_CLICK]:
        'mortgage.homeloans-dashboard-product.call-scheduler-book-appointment-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_EXIT_CLICK]:
        'mortgage.homeloans-dashboard-product.call-scheduler-exit-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_CONFIRMED]:
        'mortgage.homeloans-dashboard-product.call-scheduler-appointment-confirmation-viewed',
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_SUCCESS_DASHBOARD_BUTTON_CLICK]:
        'mortgage.homeloans-dashboard-product.call-scheduler-success-dashboard-button-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_FAILURE_DASHBOARD_BUTTON_CLICK]:
        'mortgage.homeloans-dashboard-product.call-scheduler-failure-dashboard-button-clicked',
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_FAILED]:
        'mortgage.homeloans-dashboard-product.call-scheduler-appointment-failure-viewed',
};
